import { IInitialState } from 'src/store/initialState';

const allWarrantySelector = (state: IInitialState): IInitialState['warranty'] =>
  state.warranty;

export const warrantyProvidersSel = (state: IInitialState) =>
  allWarrantySelector(state).warrantyProviders;
export const warrantyChecksSel = (state: IInitialState) =>
  allWarrantySelector(state).warrantyChecks;
export const warrantyIsPendingSel = (state: any) =>
  allWarrantySelector(state).isPending;
export const warrantyErrorSel = (state: any) =>
  allWarrantySelector(state).error;
